import { TextField, TextFieldProps } from "@mui/material";

interface ReadOnlyTextInputProps extends Omit<TextFieldProps, "variant"> {
  value: string;
  label: string;
}

export default function ReadOnlyTextInput({
  value,
  label,
  ...rest
}: ReadOnlyTextInputProps) {
  const hasValue = Boolean(value);

  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      disabled
      variant="outlined"
      InputProps={{
        style: {
          opacity: hasValue ? 1 : 0.4,
          pointerEvents: "none",
          fontWeight: hasValue ? "bold" : "normal",
        },
      }}
      {...rest}
    />
  );
}
